/**
 * Scannable directory employers that tend to matter for FS / payments /
 * platform exec searches. Used by Explore "Enable recommended" action.
 */
export const RECOMMENDED_FS_SCAN_SLUGS = [
  "brex",
  "coinbase",
  "plaid",
  "ramp",
  "shopify",
] as const;

export function isRecommendedFsScanSlug(slug: string): boolean {
  return (RECOMMENDED_FS_SCAN_SLUGS as readonly string[]).includes(slug);
}
